import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=f3f73f34&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f73f34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3f73f34')) {
      api.createRecord('f3f73f34', component.options)
    } else {
      api.reload('f3f73f34', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=f3f73f34&scoped=true&", function () {
      api.rerender('f3f73f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BnMwcmWGIpFp/JS/comp/Accordion.vue"
export default component.exports